<template>
    <b-row class="mb-5">
        <b-col md="12">
          <div class="pt-2 pb-2 float-right">
            <b-button variant="primary" style="margin-top:-100px!important; margin-right:10px!important;" class="btn-back btn-custom" @click="doModal"><font-awesome-icon icon="plus"/></b-button>
          </div>
          <paginated-table ref="dataTable" :can-edit="false" :can-delete="false" :can-approve="false" :can-reject="false" :can-show="true" :can-show-route-path="'#/vehicle/type-vehicle-detail'" :can-edit-modal="false" :can-paid="false" v-on:editData="doEdit" :data-url="apiUrl.vehicleBill" :data-key="dataKey" :data-columns="columns">
          </paginated-table>
        </b-col>
      <type-vehicle-modal ref="typeVehicleModal" :type-vehicle="'Other Report'" v-on:getVehicleBill="getVehicleBill"></type-vehicle-modal>
      <!-- <edit-road-tax-modal ref="editRoadTax" v-on:getVehicleBill="getVehicleBill"></edit-road-tax-modal> -->
    </b-row>
</template>
<script>
  import PaginatedTable from '@/components/PaginatedTable'
  import TypeVehicleModal from './TypeVehicleModal'
  // import EditRoadTaxModal from './EditRoadTaxModal'
  export default {
    props: {
      vehicleUuid: {
        type: String,
        required: false
      }
    },
    components: {
      PaginatedTable,
      TypeVehicleModal
      // EditRoadTaxModal
    },
    data () {
        return {
            dataKey: "vehicleBillInfo",
            type: "OtherReport",
            isLoading: false,
            apiUrl: {
                vehicleRequest: window.AppConfig.apiUrl + 'vehicle-request',
                vehicleBill: window.AppConfig.apiUrl + 'vehicle-bill-info?vehicle_uuid=' + this.vehicleUuid + '&type=Other Report',
            },
            columns: [
                {
                    label: 'Number',
                    key: 'billNumber',
                    sortable: true
                }, {
                    key: 'dueDate',
                    label: 'Due Date',
                    sortable: true
                }, {
                    key: 'amount',
                    sortable: true
                }, {
                    key: 'status',
                    sortable: true
                }, {
                    key: 'note',
                    sortable: true
                }, {
                    key: 'actions',
                    label: '',
                    sortable: false
                }
            ],
            vehicleRequestList: []
        }
    },
    methods: {
        getVehicleBill () {
            this.isLoading = true
            this.$refs.dataTable.getDataTable()
        },
        getDateTime (value) {
            if (value !== null) {
                return this.$moment(value).format('YYYY-MM-DD HH:mm A')
            } else {
                return '-'
            }
        },
        doModal () {
          this.$refs.typeVehicleModal.showModal()
        },
        doEdit (row) {
          this.$refs.editRoadTax.showModal(row)
        },
        doShowModal (row) {
          this.$refs.editRoadTax.showModal(row)
        },
    }
  }
</script>